var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuYoubookerW(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 25,
    viewBox: "0 0 50 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.217 7.608C29.2172 8.42073 28.9764 9.21526 28.525 9.89111C28.0736 10.567 27.432 11.0938 26.6812 11.4049C25.9304 11.7161 25.1041 11.7976 24.307 11.6392C23.5099 11.4807 22.7776 11.0895 22.2029 10.5149C21.6281 9.94024 21.2367 9.20809 21.0781 8.41099C20.9194 7.6139 21.0007 6.78766 21.3117 6.03679C21.6227 5.28591 22.1493 4.64411 22.8251 4.19256C23.5008 3.74101 24.2953 3.5 25.108 3.5C26.1976 3.5 27.2426 3.93277 28.0132 4.70315C28.7837 5.47352 29.2168 6.5184 29.217 7.608Z",
    fill: "#CECECE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 23.4197C16 21.046 16.9429 18.7696 18.6214 17.0911C20.2998 15.4127 22.5763 14.4697 24.95 14.4697C27.3237 14.4697 29.6002 15.4127 31.2786 17.0911C32.9571 18.7696 33.9 21.046 33.9 23.4197H16Z",
    fill: "#CECECE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuYoubookerW);
export default __webpack_public_path__ + "static/media/menu_youbooker_w.9e11c03ddd5859cfcb5687ab584a2157.svg";
export { ForwardRef as ReactComponent };